export const productConstants = {
  productTypeIds: [-1601, -1656, -1657],
};

export const rvCalculationCodeConstants = {
  AOLRV: "AOLRV",
};

export const scheduleTypeCellParams = {
  capitalPercentCode: "SuplementaryPrincipalPercent",
};

export const serviceCalculationTypeId = {
  FinancedValuePercent: -2044,
  PurchasePricePercent: -2048,
  ExactValue: -2046,
};
